import React,{ useEffect, useState } from 'react';
import Markup from './markup/Markup';
import useScrollPosition from "use-scroll-position";
import './css/plugins.css';
import './css/style.css';
import './css/templete.css';
import './css/skin/skin-1.css';
import './plugins/slick/slick.min.css';
import './plugins/slick/slick-theme.min.css';
import 'react-modal-video/css/modal-video.min.css';
import ReactLoading from "react-loading";
import loadingpic from "./loading.png"
import loadingGif from "./loadingGif.gif"

function App() {
	const [body_, setbody_] = useState();
	const [header, setHeader] = useState("fixed");
	const [header_, setHeader_] = useState();
	let scrollPosition = useScrollPosition();
	const [loading, setLoading] = useState(undefined);
	

	useEffect(() => {
		setbody_(document.querySelector("body"));
		setHeader_(document.getElementsByClassName("main-bar-wraper"));
	  }, []);
	  
	  useEffect(() => {
		setTimeout(() => {
		  setLoading(true);
		},5000)
	  }, []);

	var element = document.getElementById("fix-header"); 	
		
	if(typeof(element) != 'undefined' && element != null){
		header === "fixed" && scrollPosition > 10
			? header_ && header_[0].classList.add("is-fixed")
			: header_ && header_[0].classList.remove("is-fixed"); 	
	}
  return (
    <div className="App">
      {!loading ? (
        <div style={{display: "flex", flexDirection:"column", alignItems: "center" , margin:"150px auto", padding:"20px"}}>
        
		  <img src={loadingGif} alt="loading"  />

		  <img src={loadingpic} alt="Logo" style={{height:"150px",width:"150px"}} />
          <p>Welcome to Juba Proper International College Day and Boarding School</p>
        </div>
      ) : (
        <Markup />
      )}
    </div>
  );
}

export default App;
